import React, { Component } from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CSelect,
  CFormGroup,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import config from "../../../config/config";
import axios from "axios";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: true,
      selected_vehicle_type: "",
      vehicle_type_array: [],
      username: "",
      passowrd: "",
      Vehicle_Type: config.vehicle_type_array,
      menuItem: {},
    };
    this.changeForm = this.changeForm.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  changeForm(e) {
    var name = e.target.name;
    var val = e.target.value;

    this.setState({
      [name]: val,
    });
  }

  submitForm(e) {
    e.preventDefault();
    const APIURL = config.API_URL + "/user/login";
    const data = {
      username: this.state.username,
      password: this.state.password,
    };
    axios
      .post(APIURL, data)
      .then(async (res) => {
        localStorage.setItem("islogin", "");
        localStorage.setItem("userData", "");
        localStorage.setItem("userToken", "");
        localStorage.setItem("role", "");
        localStorage.setItem("priviledgeslist", "");

        if (res.data.status) {
          localStorage.setItem("islogin", true);
          localStorage.setItem("userData", JSON.stringify(res.data.userData));
          localStorage.setItem("userToken", res.data.userToken);
          localStorage.setItem("role", res.data.userData.role_id);
          localStorage.setItem(
            "priviledgeslist",
            res.data.userData.priviledgeslist
          );
          console.log("userData ==> ", res.data.userData);
          this.getMenuItems(res.data.userData, res.data.userToken);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.msg) {
            alert(error.response.data.msg);
          } else {
            alert(error.response.data.err);
          }
        }
        // res.json({ error: error });
      });
  }

  getMenuItems(userdata, token) {
    let data = {};
    const APIURL =
      config.API_URL + "/user/mainMenu?role_id=" + userdata.role_id;

    var bearer = token;

    axios
      .get(APIURL, { headers: { Authorization: bearer } })
      .then((r) => {
        if (r.status == 200) {
          localStorage.setItem("menuItem", JSON.stringify(r.data.data));
          let data = JSON.parse(localStorage.getItem("userData"));
          if (data.selected_vehicle_type && data.selected_vehicle_type != "") {
            window.location.href = "/dashboard";
          } else {
            alert("Vehicle Type is not assigned to User!!");
          }
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response) {
          if (error.response.data.msg) {
            alert(error.response.data.msg);
          } else {
            alert(error.response.data.err);
          }
        }
        // res.json({ error: error });
      });
  }

  render() {
    return (
      <div className="c-app c-default-layout flex-row align-items-center">
        <CContainer>
          <CRow
            className="justify-content-center"
            style={{ display: this.state.login ? "flex" : "none" }}
          >
            <CCol md="8">
              <CCardGroup>
                <CCard className="p-4">
                  <CCardBody>
                    <CForm>
                      <h1>Login</h1>
                      <p className="text-muted">Sign In to your account</p>
                      <CInputGroup className="mb-3">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <CIcon name="cil-user" />
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CInput
                          type="text"
                          name="username"
                          placeholder="Username"
                          autoComplete="username"
                          value={this.state.username}
                          onChange={this.changeForm}
                        />
                      </CInputGroup>
                      <CInputGroup className="mb-4">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <CIcon name="cil-lock-locked" />
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CInput
                          type="password"
                          name="password"
                          placeholder="Password"
                          autoComplete="current-password"
                          value={this.state.password}
                          onChange={this.changeForm}
                        />
                      </CInputGroup>

                      <CRow>
                        <CCol xs="6">
                          <CButton
                            color="primary"
                            className="px-4"
                            onClick={this.submitForm}
                          >
                            Login
                          </CButton>
                        </CCol>
                        {/* <CCol xs="6" className="text-right">
                        <CButton color="link" className="px-0">Forgot password?</CButton>
                      </CCol> */}
                      </CRow>
                    </CForm>
                  </CCardBody>
                </CCard>
                {/* <CCard className="text-white bg-primary py-5 d-md-down-none" style={{ width: '44%' }}>
                <CCardBody className="text-center">
                   <div>
                    <h2>Sign up</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                      labore et dolore magna aliqua.</p>
                    <Link to="/register">
                      <CButton color="primary" className="mt-3" active tabIndex={-1}>Register Now!</CButton>
                    </Link>
                  </div> 
                </CCardBody>
              </CCard> */}
              </CCardGroup>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    );
  }
}
export default Login;
